import { $tag, TaggedEnumUnion, extendEnum, tagEnum } from '@suntex.core/types';

import { buildStaticContext } from '../utils';

import { $ModuleArea, ModuleArea } from './module-area';
import { $NumberFamily, NumberFamily } from './number-family';

const $ = 'GymMode';

export const GymMode = {
  WholeNumbers: extendEnum($, NumberFamily.WholeNumbers),
  Fractions: extendEnum($, NumberFamily.Fractions),
  Decimals: extendEnum($, NumberFamily.Decimals),
  Integers: extendEnum($, NumberFamily.Integers),
  K2: tagEnum($, 4),
} as const;

export type GymMode = TaggedEnumUnion<typeof GymMode>;

const GymModes = {
  [$tag]: $,
  [GymMode.WholeNumbers]: {
    ...$NumberFamily.describe(NumberFamily.WholeNumbers),
    value: GymMode.WholeNumbers,
    steps: 12,
  },
  [GymMode.Fractions]: {
    ...$NumberFamily.describe(NumberFamily.Fractions),
    value: GymMode.Fractions,
    steps: 12,
  },
  [GymMode.Decimals]: {
    ...$NumberFamily.describe(NumberFamily.Decimals),
    value: GymMode.Decimals,
    steps: 12,
  },
  [GymMode.Integers]: {
    ...$NumberFamily.describe(NumberFamily.Integers),
    value: GymMode.Integers,
    steps: 12,
  },
  [GymMode.K2]: {
    value: GymMode.K2,
    slug: 'k2',
    label: 'K2',
    steps: 10,
    color: $ModuleArea.describe(ModuleArea.K2World).color,
  },
} as const;

export const $GymMode = buildStaticContext(GymModes);
